import React from 'react';
import { FadeIn } from './FadeIn';
import { Clock, AlertTriangle } from 'lucide-react';
export function HiddenCost() {
  return <section className="py-16 md:py-24 px-4 bg-black border-y border-sand/10" data-id="element-113">
      <div className="max-w-2xl mx-auto" data-id="element-114">
        <FadeIn data-id="element-115">
          <div className="relative rounded-3xl border border-red-500/40 bg-gradient-to-b from-red-950/20 via-black to-black p-8 md:p-12" style={{
          boxShadow: '0 0 60px rgba(239, 68, 68, 0.25), inset 0 0 40px rgba(239, 68, 68, 0.08)'
        }} data-id="element-116">
            {/* Tag */}
            <div className="flex justify-center mb-6" data-id="element-117">
              <div className="inline-flex items-center gap-2 text-red-500 text-xs md:text-sm font-bold tracking-widest uppercase" data-id="element-118">
                <span className="w-2 h-2 rounded-full bg-red-500 shadow-[0_0_10px_rgba(239,68,68,0.8)]" data-id="element-119" />
                Alerta · Costo oculto
              </div>
            </div>

            {/* Title */}
            <h2 className="font-display text-3xl md:text-5xl font-bold text-cream text-center leading-tight mb-4" data-id="element-120">
              Dejá de pagar con tu
              <br data-id="element-121" />
              <span className="text-red-500" data-id="element-122">tiempo libre</span>.
            </h2>

            <p className="text-center text-cream/70 text-base md:text-lg mb-10" data-id="element-123">
              El verdadero costo oculto de improvisar la consulta:
            </p>

            {/* Hero stat */}
            <div className="text-center mb-10" data-id="element-124">
              <div className="font-display font-black leading-none mb-4" data-id="element-125">
                <span className="text-red-500 text-7xl md:text-8xl" style={{
                textShadow: '0 0 40px rgba(239, 68, 68, 0.5)'
              }} data-id="element-126">
                  +100
                </span>
                <span className="text-red-500 text-3xl md:text-4xl font-bold ml-2" data-id="element-127">
                  hrs
                </span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl font-bold text-cream tracking-wide mb-2" data-id="element-128">
                PERDIDAS AL AÑO
              </h3>
              <p className="text-cream/60 text-base" data-id="element-129">de tu vida personal</p>
            </div>

            {/* Divider */}
            <div className="h-px bg-gradient-to-r from-transparent via-red-500/30 to-transparent mb-8" data-id="element-130" />

            {/* Stat rows */}
            <div className="space-y-4" data-id="element-131">
              <div className="flex items-start gap-4 bg-black/60 border border-red-500/15 rounded-2xl p-4 md:p-5" data-id="element-132">
                <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center justify-center" data-id="element-133">
                  <Clock size={22} className="text-red-500" data-id="element-134" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-135">
                  <h4 className="font-bold text-cream text-base md:text-lg mb-1" data-id="element-136">
                    2 a 4 horas por semana
                  </h4>
                  <p className="text-cream/60 text-sm md:text-base" data-id="element-137">
                    armando materiales y explicaciones a mano.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 bg-black/60 border border-red-500/15 rounded-2xl p-4 md:p-5" data-id="element-138">
                <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center justify-center" data-id="element-139">
                  <AlertTriangle size={22} className="text-red-500" data-id="element-140" />
                </div>
                <div className="flex-1 min-w-0" data-id="element-141">
                  <h4 className="font-bold text-cream text-base md:text-lg mb-1" data-id="element-142">
                    Fines de semana, noches y familia
                  </h4>
                  <p className="text-cream/60 text-sm md:text-base" data-id="element-143">
                    tiempo que ya no vuelve.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}